import { Tag } from '../../cdl/Tag/Tag';
import { translate } from '../helpers/translate.helper';

export const AgentImportedLabel = () => {
    return <Tag variant="default">{translate('selectAgent.imported')}</Tag>;
};
